import { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import StoreSteps from "../manageProfile/storeStepper";



const AddStoreInfo = () => {

    const navigate = useNavigate();



    return (
        <>
            <div className="main_title">
                <h1>Add Store</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
                    <button onClick={() => navigate("/store-management")}>Manage Stores</button> -
                    Add Store
                </p>
            </div>

            <div className="cards">

                <StoreSteps />

            </div>
        </>
    );
};

export default AddStoreInfo;
